import { z } from 'zod';
import { FocusArea } from 'libs/end-to-end/src/focus-area';
import { MyMetricDefinition } from 'libs/end-to-end/src/my-metric-definition';
import { ControlVariableDefinition } from 'libs/end-to-end/src/types/databases/controls/control-variable';
import { FocusAreaDefinitionIconConfiguration } from 'libs/end-to-end/src/types/databases/focus-areas/focus-area-definition';

export const MyFocusAreaDefinition = z
  .object({
    focusArea: FocusArea,
    displayName: z.string(),
    isVisible: z.boolean(),
    controlVariables: z.array(ControlVariableDefinition),
    metrics: z.array(MyMetricDefinition),
    dataIntelligenceDeepDiveFilterSetName: z.string().nullable(),
    binScatterMultiSelectFilterSetName: z.string().nullable(),
    iconConfiguration: FocusAreaDefinitionIconConfiguration,
  })
  .describe('MyFocusAreaDefinition');

export type MyFocusAreaDefinition = z.infer<typeof MyFocusAreaDefinition>;
